import { useEffect } from "react";

const SchemaMarkup = () => {
    useEffect(() => {
        const script = document.createElement("script");
        script.type = "application/ld+json";
        script.innerHTML = JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Website",
            "name": "Facility Standard",
            "url": "https://facilitystandard.com/",
            "description": "Facility Standard is a customized digital marketplace for products needed to run facilities, including supplies, furnishings, and more.",
            "publisher": {
                "@type": "Organization",
                "name": "Facility Standard",
                "logo": {
                    "@type": "ImageObject",
                    "url": "https://facilitystandard.com/logo.jpg",
                    "width": 200,
                    "height": 60
                }
            },
            "contactPoint": {
                "@type": "ContactPoint",
                "telephone": "+1-816-768-6179",
                "contactType": "customer service",
                "email": "support@facilitystandard.com",
                "availableLanguage": "English"
            }
        });

        document.head.appendChild(script);

        return () => {
            document.head.removeChild(script);
        };
    }, []);

    return null;
};

export default SchemaMarkup;
